// SPDX-License-Identifier: AGPL-3.0-or-later
import { parseCsv } from "./csv.js";
import { applyMapping, detectProfile, fingerprints } from "./profiles.js";
export * from "./csv.js";
export * from "./parse.js";
export * from "./profiles.js";
export * from "./categorize.js";
export * from "./transfers.js";
/**
 * Reads a bank CSV into a preview. Nothing is saved: the user reviews the
 * preview, and duplicates of transactions already imported are flagged
 * rather than silently dropped.
 */
export function previewImport(text, existingFingerprints = new Set(), mapping) {
    const rows = parseCsv(text);
    const detection = mapping ? null : detectProfile(rows);
    const used = mapping ?? detection?.mapping ?? null;
    if (!used)
        return { profile: null, mapping: null, rows, transactions: [], errors: [] };
    const { transactions, errors } = applyMapping(rows, used);
    const prints = fingerprints(transactions);
    return {
        profile: detection?.profile ?? null,
        mapping: used,
        rows,
        transactions: transactions.map((t, i) => ({
            ...t,
            fingerprint: prints[i],
            duplicate: existingFingerprints.has(prints[i]),
        })),
        errors,
    };
}
//# sourceMappingURL=index.js.map